import { useEffect, useRef } from "react";
import { TextB, TextItalic, TextUnderline, ListBullets, ListNumbers, LinkSimple, LinkBreak, TextAa } from "@phosphor-icons/react";
import { VARS } from "./render";

const TOOLS = [
  [TextB, "Gras", "bold"], [TextItalic, "Italique", "italic"], [TextUnderline, "Souligné", "underline"],
  [ListBullets, "Liste à puces", "insertUnorderedList"], [ListNumbers, "Liste numérotée", "insertOrderedList"],
];

const Tool = ({ icon: Icon, title, onClick, testid, disabled }) => (
  <button type="button" title={title} aria-label={title} disabled={disabled} onMouseDown={(e) => e.preventDefault()} onClick={onClick} data-testid={testid}
    className="p-1.5 rounded text-muted hover:text-accent hover:bg-surface transition-colors disabled:opacity-40">
    <Icon size={15} weight="bold" />
  </button>
);

// Éditeur d'email propre à l'ADMIN Lead Intelligence (mise en forme simple + variables).
export function EmailEditor({ value, onChange, disabled, testid = "lead-email-editor" }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el && document.activeElement !== el && el.innerHTML !== (value || "")) el.innerHTML = value || "";
  }, [value]);
  const emit = () => onChange(ref.current?.innerHTML || "");
  const exec = (cmd, arg = null) => {
    ref.current?.focus();
    document.execCommand("defaultParagraphSeparator", false, "p");
    document.execCommand(cmd, false, arg);
    emit();
  };
  const link = () => {
    const url = (window.prompt("Adresse du lien (https://… ou mailto:…)") || "").trim();
    if (url && /^(https?:|mailto:)/i.test(url)) exec("createLink", url);
  };
  return (
    <div className={`border border-border rounded-md bg-surface-2 ${disabled ? "opacity-70" : ""}`}>
      <div className="flex flex-wrap items-center gap-1 px-2 py-1.5 border-b border-border">
        {TOOLS.map(([icon, title, cmd]) => <Tool key={cmd} icon={icon} title={title} disabled={disabled} onClick={() => exec(cmd)} testid={`${testid}-${cmd}`} />)}
        <Tool icon={LinkSimple} title="Insérer un lien" disabled={disabled} onClick={link} testid={`${testid}-link`} />
        <Tool icon={LinkBreak} title="Retirer le lien" disabled={disabled} onClick={() => exec("unlink")} testid={`${testid}-unlink`} />
        <Tool icon={TextAa} title="Effacer la mise en forme" disabled={disabled} onClick={() => exec("removeFormat")} testid={`${testid}-clear`} />
        <span className="mx-1 h-4 w-px bg-border" />
        <span className="text-[11px] text-muted mr-0.5">Insérer :</span>
        {Object.entries(VARS).map(([k, label]) => (
          <button key={k} type="button" title={label} disabled={disabled} onMouseDown={(e) => e.preventDefault()} onClick={() => exec("insertText", `{{${k}}}`)}
            data-testid={`${testid}-var-${k}`} className="text-[11px] font-mono rounded border border-accent/30 text-accent px-1.5 py-0.5 hover:bg-accent/10 disabled:opacity-40">
            {`{{${k}}}`}
          </button>
        ))}
      </div>
      <div ref={ref} contentEditable={!disabled} suppressContentEditableWarning onInput={emit} onBlur={emit} data-testid={testid}
        className="lead-email-body min-h-[220px] max-h-[50vh] overflow-y-auto px-4 py-3 text-sm text-fg leading-relaxed outline-none" />
    </div>
  );
}
